export const NOTE_CATEGORIES = [
  { value: "Idea", label: "Idea" },
  { value: "Reminder", label: "Reminder" },
  { value: "Question", label: "Question" },
  { value: "Discussion", label: "Discussion" },
  { value: "Win", label: "Win" },
  { value: "Concern", label: "Concern" },
  { value: "Later", label: "Later" },
];

export const NOTE_COLUMNS = [
  { value: "Steven", label: "Steven" },
  { value: "Richard", label: "Richard" },
  { value: "Shared", label: "Shared" },
  { value: "This Week", label: "This Week" },
  { value: "Later", label: "Later" },
  { value: "Need to Discuss", label: "Need to Discuss" },
];

export const NOTE_COLOURS = [
  { value: "Yellow", label: "Yellow" },
  { value: "Blue", label: "Blue" },
  { value: "Green", label: "Green" },
  { value: "Pink", label: "Pink" },
  { value: "Orange", label: "Orange" },
  { value: "Purple", label: "Purple" },
];

// Post-it colour styles — soft, controlled backgrounds with a matching accent.
const COLOUR_STYLE = {
  Yellow: { bg: "#FEF7DA", border: "#F2E3A0", accent: "#B8860B", dot: "#FACC15" },
  Blue: { bg: "#E4EEFC", border: "#BFD6F5", accent: "#1D4ED8", dot: "#3B82F6" },
  Green: { bg: "#E1F5E7", border: "#B7E3C3", accent: "#15803D", dot: "#22C55E" },
  Pink: { bg: "#FCE4EE", border: "#F6C2D6", accent: "#BE185D", dot: "#EC4899" },
  Orange: { bg: "#FDEBD8", border: "#F7CFA6", accent: "#C2410C", dot: "#F97316" },
  Purple: { bg: "#EEE7FB", border: "#D5C6F2", accent: "#6D28D9", dot: "#8B5CF6" },
};
export const colourStyle = (c) => COLOUR_STYLE[c] || COLOUR_STYLE.Yellow;

// Default category → colour mapping. Applied automatically unless a note's
// colour has been manually overridden (colour_manual_override === true).
export const CATEGORY_DEFAULT_COLOUR = {
  Idea: "Yellow", Question: "Blue", Win: "Green", Discussion: "Pink",
  Reminder: "Orange", Concern: "Purple", Later: "Yellow",
};
export const categoryDefaultColour = (c) => CATEGORY_DEFAULT_COLOUR[c] || "Yellow";

export const NOTE_VISIBILITY = [
  { value: "Both founders", label: "Both founders" },
  { value: "Steven only", label: "Steven only" },
  { value: "Richard only", label: "Richard only" },
];

export const NOTE_STATUS = [
  { value: "Active", label: "Active" },
  { value: "Reviewed", label: "Reviewed" },
  { value: "Converted", label: "Converted" },
  { value: "Archived", label: "Archived" },
];

export const NOTE_WORKSTREAMS = [
  { value: "Product and Content", label: "Product and Content" },
  { value: "Launch", label: "Launch" },
  { value: "Marketing", label: "Marketing" },
  { value: "Investors", label: "Investors" },
  { value: "Finance", label: "Finance" },
  { value: "Operations", label: "Operations" },
  { value: "Future Innovations", label: "Future Innovations" },
  { value: "Other", label: "Other" },
];

export const CONVERT_TARGETS = [
  { value: "Task", label: "Task" },
  { value: "Priority", label: "Priority" },
  { value: "Blocker", label: "Blocker" },
  { value: "Decision", label: "Decision" },
  { value: "Future Innovation", label: "Future Innovation" },
  { value: "Company Update", label: "Company Update" },
  { value: "Weekly Review highlight", label: "Weekly Review highlight" },
];

export const NOTE_SORTS = [
  { value: "pinned", label: "Pinned first" },
  { value: "newest", label: "Newest" },
  { value: "oldest", label: "Oldest" },
  { value: "updated", label: "Last updated" },
  { value: "title", label: "Title" },
];

const CAT_TONE = {
  Idea: "#0EA5A4", Reminder: "#EC4899", Question: "#F97316", Discussion: "#1D4ED8",
  Win: "#16A34A", Concern: "#DC2626", Later: "#6D28D9",
};
export const catTone = (c) => CAT_TONE[c] || "#5A6B8C";

export const statusBadgeTone = (s) =>
  ({ Active: "success", Reviewed: "info", Converted: "warning", Archived: "neutral" }[s] || "neutral");

export const founderInitials = (name) =>
  (name === "Both founders" ? "SR" : (name || "?").slice(0, 1).toUpperCase());

export const isReviewDue = (note, today) =>
  note.status === "Active" && note.review_date && note.review_date <= today;
